import { HttpService } from "./http-service";

export class InMeetingService {
  httpService = new HttpService();
  ais_agentic_api = import.meta.env.VITE_AIS_AGENTIC_API as string;
  ais_copilot_api = import.meta.env.VITE_AIS_COPILOT_API as string;
  func_app_api = import.meta.env.VITE_FA_API as string;

  // stage
  feedbackGenerateSubmit(requestPayload: any) {
    return this.httpService
      .post(this.ais_agentic_api, requestPayload)
      .then((res: any) => {
        return res;
      });
  }
  fetchCandidateDetails(requestPayload: any) {
    return this.httpService
      .post(this.ais_copilot_api + "/FetchCandidateAPI", requestPayload)
      .then((res: any) => {
        return res;
      });
    // return this.httpService.post("https://fetchcndapi.azurewebsites.net/api/FetchCandidateAPI", requestPayload).then((res:any)=>{
    //     return res;
    // });
  }

  copilotBenefitTracking(requestPayload: any): Promise<any> {
    return this.httpService
      .post(this.func_app_api + "/CopilotBenefitTracking", requestPayload)
      .then((res: any) => {
        return res;
      });
  }

  copilotAcceptanceMatrix(requestPayload: any): Promise<any> {
    return this.httpService
      .post(this.func_app_api + "/CopilotAcceptanceMatrix", requestPayload)
      .then((res: any) => {
        return res;
      });
  }

  FetchCandidateMeetings(requestPayload: any): Promise<any> {
    return this.httpService
      .post(
        this.ais_copilot_api + "/FetchCandidateDetailsFromDB",
        requestPayload
      )
      .then((res: any) => {
        return res;
      });
  }

  CreateMeeting(requestPayload: any): Promise<any> {
    return this.httpService
      .post(this.ais_copilot_api + "/TeamsMeeting", requestPayload)
      .then((res: any) => {
        return res;
      });
  }

  CancelRescheduleMeeting(requestPayload: any): Promise<any> {
    return this.httpService
      .post(this.ais_copilot_api + "/CancelOrRescheduleMeeting", requestPayload)
      .then((res: any) => {
        return res;
      });
  }

  SubmitFeedback(requestPayload: any): Promise<any> {
    return this.httpService
      .post(this.ais_copilot_api + "/SubmitFeedbackAPI", requestPayload)
      .then((res: any) => {
        return res;
      });
  }

  // local

  // feedbackGenerateSubmit(requestPayload :any){
  //     return this.httpService.post("https://fetchcndapi.azurewebsites.net/api/aisstream", requestPayload).then((res:any)=>{
  //         return res;
  //     });

  // }
  // fetchCandidateDetails(requestPayload :any){

  //     return this.httpService.post("https://fetchcndapi.azurewebsites.net/api/FetchCandidateAPI", requestPayload).then((res:any)=>{
  //         return res;
  //     });

  // }

  // copilotBenefitTracking(requestPayload :any): Promise<any>{
  //      return this.httpService.post("https://func-lix-29210802fbgen.azurewebsites.net/api/CopilotBenefitTracking", requestPayload).then((res:any)=>{
  //         return res;
  //     });
  // }

  // copilotAcceptanceMatrix(requestPayload :any): Promise<any>{
  //      return this.httpService.post("https://func-lix-29210802fbgen.azurewebsites.net/api/CopilotAcceptanceMatrix'", requestPayload).then((res:any)=>{
  //         return res;
  //     });
  // }
}
